import { getBenefitProgramLabel, outcomeLabels } from "@/lib/benefit-enums"
import { enumLabel } from "@/lib/benefit-format"
import type { BenefitGrantDto } from "@/lib/benefit-types"

export function GrantOutcomes({ grants }: { grants: BenefitGrantDto[] }) {
  const rows = grants.flatMap((grant) => {
    const outcomes = grant.outcomes
    if (outcomes == null) return []

    const instance = grant.benefitProgramInstance
    return [
      <div key={`${instance.program}:${instance.year}`}>
        {getBenefitProgramLabel(instance.program)} PY {instance.year}: {enumLabel(outcomeLabels, outcomes.before)} → {enumLabel(outcomeLabels, outcomes.after)}
      </div>,
    ]
  })

  return rows.length === 0 ? <>—</> : <div className="space-y-1">{rows}</div>
}
